const COMPANY_COLORS = [
  '#4f46e5', '#0891b2', '#059669', '#d97706', '#dc2626',
  '#7c3aed', '#2563eb', '#0d9488', '#ca8a04', '#e11d48',
  '#6366f1', '#06b6d4', '#10b981', '#f59e0b', '#ef4444',
];

export function getCompanyColor(id: string): string {
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = id.charCodeAt(i) + ((hash << 5) - hash);
  }
  return COMPANY_COLORS[Math.abs(hash) % COMPANY_COLORS.length];
}

export function formatSalaryRange(min: number, max: number, currency: string): string {
  const fmt = (n: number) => {
    if (n >= 1000) return `${Math.round(n / 1000)}K`;
    return String(n);
  };
  const symbol = currency === 'USD' ? '$' : currency === 'GBP' ? '\u00A3' : currency === 'EUR' ? '\u20AC' : `${currency} `;
  return `${symbol}${fmt(min)} - ${symbol}${fmt(max)}`;
}
